import { connect } from 'react-redux'
import CrowdfundingDetailView from 'components/crowdfunding_detail_view'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { getCategoryDefaultCover } from 'client/lib/category'

const mapStateToProps = (state, ownProps) => {
  const campaign = getCampaignSelector(state, ownProps)
  const defaultCategoryCover = getCategoryDefaultCover(state, campaign.category)

  return {
    defaultCategoryCover,
    campaign,
  }
}

export default connect(mapStateToProps)(CrowdfundingDetailView)
